import { PortableText } from "@portabletext/react";
import styles from "./styles.module.scss";
import { portableTextComponents } from "../../../lib/portableTextComponents";
import Button from "../../Button";
import { urlFor } from "../../../sanity/lib/image";
import Image from "next/image";
import { Tags } from "../../tags/Tags";

export function TextWithContent({
  title,
  titleColor,
  titleAlignment,
  borderColor,
  borderWidth,
  content,
  contentAlignment,
  buttons,
  buttonAlignment,
  columns,
}) {
  return (
    <div
      className={styles.textWithContent}
      style={{
        "--border-color": borderColor?.hex,
        "--border-width": `${borderWidth}px`,
      }}
    >
      <div className={styles.contentTop}>
        <h2
          className={`${styles.title} ${styles[titleAlignment]}`}
          style={
            titleColor
              ? {
                  color: `rgba(${titleColor.rgb.r},${titleColor.rgb.g},${titleColor.rgb.b},${titleColor.rgb.a})`,
                }
              : {}
          }
        >
          {title}
        </h2>
        <div className={`${styles.content} ${styles[contentAlignment]}`}>
          <PortableText value={content} components={portableTextComponents} />
        </div>
        {buttons?.length > 0 && (
          <div className={`${styles.buttonGroup} ${styles[buttonAlignment]}`}>
            {buttons.map((button) =>
              button?.isExternal ? (
                <Button
                  type="link"
                  key={button.url}
                  href={button.url}
                  className={button.color || "primary"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {button.text}
                </Button>
              ) : (
                <Button
                  type="link"
                  key={button.url}
                  href={button.url}
                  className={button.color || "primary"}
                >
                  {button.text}
                </Button>
              )
            )}
          </div>
        )}
      </div>
      <div
        className={styles.contentBottom}
        style={{
          "--column-count": columns?.length,
        }}
      >
        {columns?.length > 0 && (
          <div className={styles.columns}>
            {columns.map((column) => (
              <div
                key={column._key}
                className={styles.column}
                data-image-position={column.imageAlignment}
                data-column-width={column.columnWidth}
                style={{
                  "--column-width": `${column.columnWidth}%`,
                }}
              >
                <div
                  className={styles.textWrapper}
                  style={{
                    "--flex-basis": `${100 - column.imageWidth}%`,
                  }}
                >
                  {column.title && (
                    <h3
                      style={
                        column.titleColor
                          ? {
                              color: `rgba(${column.titleColor.rgb.r},${column.titleColor.rgb.g},${column.titleColor.rgb.b},${column.titleColor.rgb.a})`,
                            }
                          : {}
                      }
                    >
                      {column.title}
                    </h3>
                  )}
                  <PortableText
                    value={column.content}
                    components={portableTextComponents}
                  />
                  <Tags tags={column.tags} wrapperStyles={styles.tags} />
                  {column.buttons?.length > 0 && (
                    <div className={`${styles.buttonGroup}`}>
                      {column.buttons.map((button) =>
                        button?.isExternal ? (
                          <Button
                            type="link"
                            key={button._key}
                            href={button.url}
                            className={button.color || "primary"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {button.text}
                          </Button>
                        ) : (
                          <Button
                            type="link"
                            key={button._key}
                            href={button.url}
                            className={button.color || "primary"}
                          >
                            {button.text}
                          </Button>
                        )
                      )}
                    </div>
                  )}
                </div>
                {column.image && (
                  <div
                    className={styles.imageWrapper}
                    style={{
                      "--flex-basis": `${column.imageWidth}%`,
                    }}
                  >
                    <Image
                      className={styles.image}
                      src={urlFor(column.image).width(800).height(500).url()}
                      width={800}
                      height={500}
                      alt=""
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
